@if (isOpen) {
  <div
    class="fixed inset-0 bg-black/50 flex items-center justify-center p-4"
    style="z-index: var(--z-modal)"
    (click)="close()"
  >
    <div
      class="w-full max-w-lg h-[80vh] flex flex-col rounded-2xl bg-white dark:bg-gray-900 shadow-2xl overflow-hidden"
      (click)="$event.stopPropagation()"
    >
      <!-- Header -->
      <div class="flex items-center justify-between gap-2 px-5 py-4 border-b border-gray-200 dark:border-gray-700">
        <div class="min-w-0">
          <h2 class="text-base font-semibold text-gray-900 dark:text-white truncate">
            Contactos del segmento
          </h2>
          <p class="text-xs text-gray-500 dark:text-gray-400 truncate">
            {{ segmentName }} · {{ totalElements }} contacto{{ totalElements === 1 ? '' : 's' }}
          </p>
        </div>
        <button type="button" (click)="close()"
          class="p-2 rounded-lg text-gray-400 hover:text-gray-600 hover:bg-gray-100 dark:hover:text-gray-300 dark:hover:bg-gray-800">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
          </svg>
        </button>
      </div>

      <!-- Búsqueda -->
      <div class="px-5 py-3 border-b border-gray-100 dark:border-gray-800">
        <input
          type="text"
          [(ngModel)]="searchTerm"
          (ngModelChange)="onSearchChange()"
          placeholder="🔍 Buscar por nombre o email…"
          class="w-full rounded-full border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 px-4 py-2 text-sm text-gray-900 dark:text-white"
        />
      </div>

      <!-- Lista con scroll infinito -->
      <div class="flex-1 min-h-0 overflow-y-auto px-2 py-2" (scroll)="onScroll($event)">
        @if (loading) {
          <div class="flex justify-center py-10">
            <div class="animate-spin rounded-full h-6 w-6 border-b-2 border-brand-500"></div>
          </div>
        } @else if (members.length === 0) {
          <p class="py-10 text-center text-sm text-gray-500">
            {{ searchTerm ? 'No hay contactos que coincidan con la búsqueda.' : 'Este segmento no tiene contactos.' }}
          </p>
        } @else {
          <ul class="divide-y divide-gray-100 dark:divide-gray-800">
            @for (m of members; track trackById($index, m)) {
              <li class="flex items-center gap-3 px-3 py-2.5">
                <div class="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-brand-50 text-brand-600 dark:bg-brand-500/15 dark:text-brand-300 text-xs font-semibold">
                  {{ (m.contact.name || m.contact.email || '?').charAt(0).toUpperCase() }}
                </div>
                <div class="min-w-0 flex-1">
                  <p class="text-sm font-medium text-gray-900 dark:text-white/90 truncate">{{ m.contact.name || '—' }}</p>
                  <p class="text-xs text-gray-500 dark:text-gray-400 truncate">{{ m.contact.email }}</p>
                </div>
              </li>
            }
          </ul>
          @if (loadingMore) {
            <div class="flex justify-center py-3">
              <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-brand-500"></div>
            </div>
          }
        }
      </div>

      <!-- Footer -->
      <div class="flex items-center justify-end px-5 py-3 border-t border-gray-200 dark:border-gray-700">
        <button type="button" (click)="close()"
          class="px-4 py-2 text-sm rounded-lg border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700">
          Cerrar
        </button>
      </div>
    </div>
  </div>
}
